import React from "react";

function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 19 19"
    >
      <path
        fill="currentColor"
        d="M5.707 17.707L15 8.414 10.586 4l-9.293 9.293a1.003 1.003 0 00-.263.464L0 19l5.242-1.03c.176-.044.337-.135.465-.263zM18 5.414a2 2 0 000-2.828L16.414 1a2 2 0 00-2.828 0L12 2.586 16.414 7 18 5.414z"
      ></path>
    </svg>
  );
}

export default EditIcon;
